import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import 'nprogress/nprogress.css'
import './assets/css/global.css'
import './assets/css/workbench-apps.css'
import './assets/font/iconfont.css'
import './assets/font/iconfont.js'
import './assets/font/fonts.css'
import { applySiteBrand, loadSiteBrand } from './utils/siteBrand'
import * as filters from './filters/index'
import onceClick from './utils/clickOnce'
import QRCode from 'qrcodejs2'
import VueAMap from 'vue-amap'
import pdf from 'vue-pdf'
import { Buffer } from 'buffer'
global.Buffer = Buffer

VueAMap.initAMapApiLoader({
  key: 'beb19b7b31dbc7cf8c0f35ace8519fa2',
  plugin: [
    'AMap.Autocomplete',
    'AMap.PlaceSearch',
    'AMap.Scale',
    'AMap.OverView',
    'AMap.ToolBar',
    'AMap.MapType',
    'AMap.PolyEditor',
    'AMap.CircleEditor',
    'AMap.Geocoder',
    'AMap.Geolocation',
    'AMap.MarkerClusterer'
  ],
  uiVersion: '1.0',
  v: '1.4.4'
})
const QRCodeSC = (url) => {
  const qrcode = new QRCode('qrcode', {
    // qrcode  html为标签id
    width: 170, // 长度
    height: 170, // 宽度
    text: url // 内容
    // render: 'canvas' // 设置渲染方式（有两种方式 table和canvas，默认是canvas)
  })
  return qrcode
}
Vue.use(VueAMap)
Vue.use(onceClick)
Vue.component('pdf', pdf)
Vue.config.productionTip = false
applySiteBrand()
loadSiteBrand()
Vue.prototype.$QRCodeSC = QRCodeSC
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key])
})
new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
